import Config from '@config';
import { initializeRolesApi } from '@gasbi/shared/common/features/roles';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  rolesApi,
  useGetRolePermissionsByIdQuery,
  useGetRoleAvailablePermissionsByIdQuery,
  useAssignRoleByIdMutation,
  useSuspendRoleByIdMutation,
} = initializeRolesApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});
